export default __webpack_public_path__ + "be9a27860b8ad1643185b68ad9b07a96.svg";